export default __webpack_public_path__ + "static/media/mask1.e270ca6b.png";